import angular from 'angular';

export default function (app) {
  app.factory('klLocalStorageService', [
    '$q',
    '$document',
    '$timeout',
    'localStorageService',
    'config',
    function ($q, $document, $timeout, LocalStorageService, config) {
      let _externalStorage;
      let _isExternal;
      let _iFrameDeferred = $q.defer();

      let storageReady = getExternal().then(() => setStorage());

      function getExternal() {
        if (_isExternal === undefined || _isExternal === null) return $timeout(getExternal, 100);
        return $q.when();
      }

      function setStorage() {
        if (!_isExternal) return $q.when();
        let iframe = document.getElementById('kl-cart-storage');
        if (!iframe) return $timeout(setStorage, 100);
        if (!!_externalStorage) return $q.when();
        _externalStorage = iframe ? iframe.contentWindow : null;
        iframe.onload = () => _iFrameDeferred.resolve();
        testStorage().then(() => _iFrameDeferred.resolve());
        return _iFrameDeferred.promise;
      }

      function setExternal(isExternal) {
        _isExternal = isExternal;
      }

      function testStorage() {
        return $q((resolve) => {
          window.onmessage = function (e) {
            resolve();
          };
          _externalStorage.postMessage(JSON.stringify({ method: 'test' }), '*');
        });
      }

      function set(key, value) {
        return storageReady.then(() => {
          if (!_externalStorage) return LocalStorageService.set(key, value);
          _externalStorage.postMessage(JSON.stringify({ key: 'kl.' + key, method: 'set', data: value }), '*');
        });
      }

      function get(key) {
        return LocalStorageService.get(key);
      }

      function fetchExternal(key) {
        return $q((resolve) => {
          window.onmessage = function (e) {
            if (e.origin != config.host) return;
            let result = JSON.parse(e.data);
            resolve(result);
          };
          _externalStorage.postMessage(JSON.stringify({ key: 'kl.' + key, method: 'get' }), '*');
        });
      }

      function fetch(key) {
        return storageReady.then(() => {
          if (!_externalStorage) return $q.resolve(LocalStorageService.get(key));
          return fetchExternal(key);
        });
      }

      function remove(key) {
        return storageReady.then(() => {
          if (!_externalStorage) return LocalStorageService.remove(key);
          _externalStorage.postMessage(JSON.stringify({ key: 'kl.' + key, method: 'remove' }), '*');
        });
      }

      return {
        set,
        get,
        fetch,
        remove,
        setExternal,
      };
    },
  ]);
}
